import axios from "axios";
import {
    IP
} from "./config";

// 查询文章列表
export async function selectArticle() {
    var resp = await axios.post(`${IP}/article/select`, {

    });
    return resp.data;
}
// 新增文章列表
export async function addArticle(form) {
    var resp = await axios.post(`${IP}/article/add`, {
        form
    });
    return resp.data;
}
// 修改文章列表
export async function updateArticle(form) {
    var resp = await axios.post(`${IP}/article/update`, {
        form
    });
    return resp.data;
}
// 删除文章列表
export async function deleteArticle(id) {
    var resp = await axios.post(`${IP}/article/delete`, {
        id
    });
    return resp.data;
}